let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8bod9")).then(() => parcelRequire('fhi35'));